export default __webpack_public_path__ + "static/media/choppingblock.9471b9d7.jpg";